export default __webpack_public_path__ + "static/media/JGN-BNB.329db352.svg";